module.exports = __webpack_public_path__ + "static/media/main.404b8fa8.png";